export default __webpack_public_path__ + "static/media/arrow-right.71b2ede3.svg";